import $ from 'jquery';
class DataLayerTracking {
	constructor() {
		this.initProductDetailPageEvent();
		this.initProductClickEvent();
	}

	initProductDetailPageEvent() {
		// PDP is opened
		if ( window.v_cl === 'details' ) {

			document.addEventListener( 'finished_change_variant', () => {

				// Fire Event here.
				this.productDetailPageEvent( false )
			} );

		}

		// Quickview for product is opened
		$( '#popup_article' ).on( 'load_article_detail_popup.acl', () => {
			this.productDetailPageEvent( true );
		} );
	}

	initProductClickEvent() {
		// Normal product click
		$( document ).on( 'click', '.en_mdl_product', ( e ) => {
			this.productClickEvent( e.currentTarget );
		} );

		// Quickview button clicked
		$( document ).on( 'click', '.en_mdl_product__cart-button', ( e ) => {
			this.productClickEvent( e.currentTarget, true );
		} );
	}

	productDetailPageEvent( quickview = false ) {
		var holder = quickview ? $( '#popup_article .article_submit_wrapper' ) : $( '.article_submit_wrapper' );
		window.dataLayer = window.dataLayer || [];

		let data = {
			'event': 'productDetailPage',
			'gtmProductDataRefresh':'updated',
			'ecommerce': {
				'currencyCode': $( 'meta[name="_isoCurrency"]' ).attr( 'content' ),
				'detail': {
					'actionField': {
						'list': quickview ? window.location.pathname : ( document.referrer.startsWith( $( 'meta[name="_ShopDomain"]' ).attr( 'content' ) ) ? document.referrer.split( '?' )[0].replace( window.location.origin, '' ) : '(external)' )
					},
					'products': [{
						'id': holder.data( 'eec-id' ),
						'name': holder.data( 'eec-name' ),
						'price': holder.data( 'eec-price' ),
						'brand': holder.data( 'eec-brand' ),
						'category': holder.data( 'eec-category' ),
						'dimension10': holder.data( 'eec-oxid' ),

					}]
				}
			}
		}

		if( quickview ) {
			data.shopLayer = 'quickview_popup';
		}

		window.dataLayer.push( data );
	}

	productClickEvent( elem, quickview = false ) {
		var holder = $( elem ).closest( 'article.en_mdl_product' );
		window.dataLayer = window.dataLayer || [];

		let data = {
			'event': 'productClick',
			'ecommerce': {
				'currencyCode': $( 'meta[name="_isoCurrency"]' ).attr( 'content' ),
				'click': {
					'actionField': {
						'list': window.location.pathname
					},
					'products': [{
						'id': holder.data( 'eec-id' ),
						'name': holder.data( 'eec-name' ),
						'price': holder.data( 'eec-price' ),
						'brand': holder.data( 'eec-brand' ),
						'category': holder.data( 'eec-category' ),
						'position': holder.data( 'eec-position' )
					}]
				}
			}
		}

		if( quickview ) {
			data.shopLayer = 'quickview_popup';
		}

		window.dataLayer.push( data );
	}
}

const initDataLayerTracking = function( ) {
	new DataLayerTracking();
}

export {
	DataLayerTracking as default,
	initDataLayerTracking
}
